import { render, staticRenderFns } from "./CompanyTobaCreate.vue?vue&type=template&id=ef18b3a6&scoped=true&"
import script from "./CompanyTobaCreate.vue?vue&type=script&lang=js&"
export * from "./CompanyTobaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef18b3a6",
  null
  
)

export default component.exports